<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{$t('addEditTourneeModele.informations.title')}}
      </p>
    </header>
    <div class="card-content columns is-multiline">
      <b-field :label="$t('addEditTourneeModele.informations.nom')"
               class="column is-4 obligatoire">
        <b-input v-model="tourneeModele.libelle"></b-input>
      </b-field>
      <b-field :label="$t('addEditTourneeModele.informations.jourDepart')"
               class="column is-2 obligatoire">
        <b-select v-model="tourneeModele.jourDepart" expanded>
          <option v-for="jour in LISTE_INDEX_JOURS"
                  :key="jour.number"
                  :value="jour.number">
            {{ ucFirst(jour.libelle)}}
          </option>
        </b-select>
      </b-field>
      <b-field :label="$t('addEditTourneeModele.informations.afficheur')"
               class="column is-4 obligatoire">
        <b-autocomplete
          v-model="afficheurSelect"
          :data="dataAfficheurs"
          field="nomCommercial"
          @select="selectAfficheur"
          @typing="getAfficheurs"
          :loading="isFetching" >
          <template slot="empty">
            <div v-if="!isFetching">
              {{$t('addEditTourneeModele.autocomplete.noRslt')}}
            </div>
            <div v-else>{{$t('addEditTourneeModele.autocomplete.search')}}</div>
          </template>
        </b-autocomplete>
      </b-field>
      <selection-agence class="column is-2" v-if="afficherAgence"
        v-model="tourneeModele.agenceId"
        obligatoire>
      </selection-agence>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import { LISTE_INDEX_JOURS } from '@/configuration/datePickerConf';
import ucFirst from '@/services/general/ucFirst';
import { TIERS_TYPE_FOURNISSEUR, TIERS_SOUS_TYPE_AFFICHEUR } from '@/configuration/tiers/tiersConf';
import { getAll } from '@/api/tiers/index';
import SelectionAgence from '@/components/general/selectionAgence';

const societe = createNamespacedHelpers('societe');

export default {
  props: {
    tourneeModele: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      LISTE_INDEX_JOURS: LISTE_INDEX_JOURS,
      afficheurSelect: null,
      isFetching: false,
      dataAfficheurs: [],
    };
  },
  components: {
    SelectionAgence,
  },
  computed: {
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societeActive: 'societeActive',
    }),
    afficherAgence() {
      return this.societeActive.agences.length > 1;
    },
  },
  methods: {
    ucFirst(libelle) {
      return ucFirst(libelle);
    },
    selectAfficheur(afficheur) {
      this.tourneeModele.afficheurId = afficheur ? afficheur.id : null;
      this.tourneeModele.afficheur = afficheur;
    },
    getAfficheurs: debounce(function afficheursData() {
      this.dataAfficheurs = [];
      this.tourneeModele.afficheurId = null;
      if (!this.afficheurSelect) return;
      this.isFetching = true;
      const query = {
        query: {
          nomCommercialCompteComptable: this.afficheurSelect,
          societeId: this.societeActiveId,
          type: TIERS_TYPE_FOURNISSEUR,
          sousType: [TIERS_SOUS_TYPE_AFFICHEUR],
          archive: false,
        },
      };
      getAll(query).then((response) => {
        response.data.result.items.forEach((tiers) => {
          if (tiers.id !== this.afficheurId) this.dataAfficheurs.push(tiers);
        });
        this.isFetching = false;
      }).catch(() => {
        this.isFetching = false;
      });
    }, 500),
  },
  mounted() {
    if (this.tourneeModele.afficheur) {
      this.afficheurSelect = this.tourneeModele.afficheur.nomCommercial;
    }
  },
};
</script>
